module.exports = __webpack_public_path__ + "img/chauffe-marcel_03_icone.0cfecaa1.svg";